import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import gsap, { Linear } from 'gsap';
import { isMobile } from 'mobile-device-detect';
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';

export default class Keeper {
  constructor(scene) {
    this.scene = scene;
    this.onEvents = this.onEvents.bind(this);
  }

  init() {
    this.events = EventDispatcher.getObj();

    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents);
    this.events.addEventListener('GAME_EVENTS', this.onEvents);

    this.keeperReady = false;
    this.mixer = null;
    this.keeperAdded = false;
    this.mixer2 = null;
    this.mixer3 = null;
    this.shootStatus = null;
    this.animKey = null;
    this.ballCaught = false;
    this.lastPosition = new THREE.Vector3();
    Global.isJumpInProgress = false;
  }

  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'create_scene':
      case 'update_keeper_jersey':
        this.addKeeper();
        break;
      case 'update':
        this.update(data['message']['data']);
        break;
      case 'assign_position':
        this.faceToBall(data['message']['data']);
        break;
      case 'defend':
        this.defend(data['message']['data']);
        break;
      case 'on_swipe':
        this.onSWipe(data['message']['data']);
        break;
      case 'goal':
        this.onGoal();
        break;

      case 'kick_ball':
        // setTimeout(() => {

        // }, 800);
        break;
      case 'dispose':
        this.dispose();
        break;
    }
  }
  updateJersey() {}
  onGoal() {
    this.keeperReady = false;

    if (!Global.isJumpInProgress) {
      this.sad.play();
    }
  }
  addKeeper() {
    if (Global.gender == null) return;

    this.keeperAdded = true;
    this.animationList = [];
    this.keeper =
      Global.assets['glbs'][`keeper${Global.gender}`]['asset'].scene;
    this.scene.add(this.keeper);
    this.keeper.rotation.y = Math.PI;
    this.keeper.position.set(-1, 0, -0.1);
    this.keeper.scale.set(
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8
    );

    this.keeperToCheer = SkeletonUtils.clone(this.keeper);
    this.scene.add(this.keeperToCheer);
    this.keeperToCheer.rotation.y = Math.PI;
    this.keeperToCheer.position.set(2, 0, -0.1);
    this.keeperToCheer.scale.set(
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8
    );
    this.keeperToCheer.visible = false;

    this.collider = Global.assets['glbs'][`collider`]['asset'].scene.clone();
    this.scene.add(this.collider);
    this.collider.scale.set(
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8,
      Global.scaleFact * 0.8
    );
    this.collider.rotation.y = Math.PI;
    this.collider.position.set(-1, 0, -1.0);

    const targetPoint = new THREE.Vector3(0, 1, -100);
    const direction = new THREE.Vector3()
      .subVectors(targetPoint, new THREE.Vector3(0, 0, 0))
      .normalize();

    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'set_camera_view',
        data: {
          position: this.keeper.position,
          direction: direction,
          rotationY: this.keeper.rotation.y,
        },
      },
    });

    this.keeper.userData = {
      canCheckIntersects: true,
      itemType: 'keeper',
    };
    this.collider.userData = {
      canCheckIntersects: true,
      itemType: 'keeper',
    };

    this.collider.traverse((child) => {
      if (!child.material) return false;
      child.material.transparent = true;
      child.material.opacity = 0;
      child.scale.x *= 1.3;
      child.material.depthWrite = false;
      child.material.side = THREE.DoubleSide;
    });

    this.keeperToCheer.traverse((child) => {
      if (!child.material) return false;

      child.castShadow = true;
      child.material.envMap = Global.envMap;
      child.material.envMapIntensity = 1.0;
      child.material.opacity = 1;
      child.material.roughness = 1;
      child.material.metalness = 0;
    });
    this.keeper.traverse((child) => {
      if (!child.material) return false;

      child.castShadow = true;
      // child.recieveShadow = true;
      child.frustumCulled = false;
      child.material.envMap = Global.envMap;
      child.material.envMapIntensity = 1.0;
      child.material.opacity = 1;
      child.material.roughness = 1;
      child.material.metalness = 0;
      // child.material.blending = THREE.NoBlending;
      // child.material.depthWrite = false;
      // child.material.side = THREE.FrontSide;
      // child.material.opacity = 0;
      // child.material.side = THREE.DoubleSide;

      if (
        Global.assets['textures'][`jersey`] &&
        child.material.map &&
        child.material.map.name.toLowerCase().indexOf('uniform') !== -1
      ) {
        const _newMap = Global.assets['textures'][`jersey`]['asset'].clone();
        _newMap.colorSpace = THREE.SRGBColorSpace;
        _newMap.flipY = false;
        child.material.map = _newMap;
        child.material.envMapIntensity = 1;
        child.material.opacity = 1;
        child.material.roughness = 1;
        child.material.metalness = 0;
      }
    });

    this.mixer = new THREE.AnimationMixer(this.keeper);
    this.mixer3 = new THREE.AnimationMixer(this.keeperToCheer);
    this.mixer2 = new THREE.AnimationMixer(this.collider);

    this.happy = this.mixer3.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'happy'
      )
    );
    this.sad = this.mixer3.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'sad'
      )
    );
    this.idle = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        '01 IDLE'
      )
    );

    this.highRight = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'DIVE 01 RIGHT'
      )
    );
    this.highLeft = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'DIVE 01 LEFT'
      )
    );

    this.midRight = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'dive 02_Right'
      )
    );
    this.midLeft = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'dive 02_Left'
      )
    );

    this.lowRight = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'DIVE 03 right'
      )
    );
    this.lowLeft = this.mixer.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`keeper${Global.gender}`]['asset']['animations'],
        'DIVE 03 left'
      )
    );

    /* Collider Animation */
    this.highRightCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE1_RIGHT'
      )
    );
    this.highLeftCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE1_LEFT'
      )
    );

    this.midRightCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE2_RIGHT'
      )
    );
    this.midLeftCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE2_Left'
      )
    );

    this.lowRightCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE3_RIGHT'
      )
    );
    this.lowLeftCollider = this.mixer2.clipAction(
      THREE.AnimationClip.findByName(
        Global.assets['glbs'][`collider`]['asset']['animations'],
        'Plane_DIVE3_Left'
      )
    );

    this.highRight.setLoop(THREE.LoopRepeat, 1);
    this.highRight.clampWhenFinished = true;
    this.highLeft.setLoop(THREE.LoopRepeat, 1);
    this.highLeft.clampWhenFinished = true;

    this.midRight.setLoop(THREE.LoopRepeat, 1);
    this.midRight.clampWhenFinished = true;
    this.midLeft.setLoop(THREE.LoopRepeat, 1);
    this.midLeft.clampWhenFinished = true;

    this.lowRight.setLoop(THREE.LoopRepeat, 1);
    this.lowRight.clampWhenFinished = true;
    this.lowLeft.setLoop(THREE.LoopRepeat, 1);
    this.lowLeft.clampWhenFinished = true;

    this.highRightCollider.setLoop(THREE.LoopRepeat, 1);
    this.highRightCollider.clampWhenFinished = true;
    this.highLeftCollider.setLoop(THREE.LoopRepeat, 1);
    this.highLeftCollider.clampWhenFinished = true;

    this.midRightCollider.setLoop(THREE.LoopRepeat, 1);
    this.midRightCollider.clampWhenFinished = true;
    this.midLeftCollider.setLoop(THREE.LoopRepeat, 1);
    this.midLeftCollider.clampWhenFinished = true;

    this.lowRightCollider.setLoop(THREE.LoopRepeat, 1);
    this.lowRightCollider.clampWhenFinished = true;
    this.lowLeftCollider.setLoop(THREE.LoopRepeat, 1);
    this.lowLeftCollider.clampWhenFinished = true;

    this.animationList.push(this.idle);
    this.animationList.push(this.highRight);
    this.animationList.push(this.highLeft);
    this.animationList.push(this.midRight);
    this.animationList.push(this.midLeft);
    this.animationList.push(this.lowRight);
    this.animationList.push(this.lowLeft);
    this.animationList.push(this.highRightCollider);
    this.animationList.push(this.highLeftCollider);
    this.animationList.push(this.midRightCollider);
    this.animationList.push(this.midLeftCollider);
    this.animationList.push(this.lowRightCollider);
    this.animationList.push(this.lowLeftCollider);
    this.animationList.push(this.happy);
    this.animationList.push(this.sad);

    // this.happyAnimation.setLoop(THREE.LoopRepeat, 2);
    // this.happyAnimation.clampWhenFinished = true;

    this.mixer.addEventListener('finished', (e) => {
      // this.keeper.visible = false;
      this.keeper.visible = false;
      if (this.jumpLevel == 'high') {
        this.keeperToCheer.position.set(
          this.jumpSide == 'Right' ? 2.8 : -4.4,
          0,
          this.jumpSide == 'Right' ? -1 : -1.4
        );
        this.keeperToCheer.rotation.y = Math.PI;
      }
      if (this.jumpLevel == 'mid') {
        this.keeperToCheer.position.set(
          this.jumpSide == 'Right' ? 1.8 : -3.6,
          0,
          this.jumpSide == 'Right' ? -1 : -1.4
        );
        this.keeper.rotation.y = 0;
      }
      if (this.jumpLevel == 'low') {
        this.keeperToCheer.position.set(
          this.jumpSide == 'Right' ? 0.75 : -2.3,
          0,
          (this.jumpSide == 'Right' ? -2.2 : -2.2) *
            (Global.gender == 'Male' ? 1 : 0.6)
        );
        this.keeperToCheer.rotation.y =
          Math.PI * (this.jumpSide == 'Right' ? 0.8 : 1.2);
      }

      this.stopAll('happy', '');
      if (this.ballCaught) {
        this.happy.play();
      } else {
        this.sad.play();
      }

      this.keeperToCheer.visible = true;
      if (
        e.action === this.rightJumpAnimation ||
        e.action === this.leftJumpAnimation1 /* && this.shootStatus!=null */
      ) {
        // if (e.action === this.defendAnimation) {
        //   this.showHappy();
        // }
        // if (e.action === this.happyAnimation) {
        //   this.playIdle();
        // }

        Global.isJumpInProgress = false;

        this.keeper.visible = false;
        this.collider.visible = false;
        // this.colliderRJ.visible = false;

        if (this.shootStatus === 'goal') this.showUnhappy();
        if (this.shootStatus !== 'goal') this.showHappy();
        this.keeper.position.copy(this.lastPosition);
        this.keeper.position.y = 0;

        // this.colliderRJ.position.copy(this.lastPosition);
        // this.colliderRJ.position.y = 0;

        this.collider.position.copy(this.lastPosition);
        // this.colliderLJ.position.y = 0;

        //this.
        gsap.delayedCall(0.1, () => {
          this.keeper.visible = true;
        });
      }
    });

    //

    // Add bounding box helper
  }

  onSWipe(data) {
    if (Global.isJumpInProgress || !this.keeperReady) return;

    this.events.dispatchEvent({
      type: 'PLAYER_EVENTS',
      message: {
        event_type: 'move_camera',
        data: {
          position: new THREE.Vector3(
            this.keeper.position.x -
              (isMobile ? 3 : 1.3) *
                (Global.jumpHeight == 'high'
                  ? 1
                  : Global.jumpHeight == 'mid'
                  ? 0.8
                  : 0.6) *
                (data.direction == 'Left' ? 1 : -1),
            this.keeper.position.y + 1,
            this.keeper.position.z
          ),
          byForce: true,
        },
      },
    });
    Global.isJumpInProgress = true;
    this.playAnimation(Global.jumpHeight, data.direction);
  }
  stopAll(level, direction) {
    this.animationList.forEach((animation) => {
      if (
        !this[`${level}${direction}`] ||
        (this[`${level}${direction}`] &&
          this[`${level}${direction}`] != animation)
      ) {
        if (this[`${level}${direction}Collider`] != animation) animation.stop();
      }
    });
  }
  showHappy() {
    if (Global.isJumpInProgress) return false;
    // this.happyAnimation.play();
    this.stopAll('happy');
  }

  showUnhappy() {
    this.shootStatus = 'goal';
    if (Global.isJumpInProgress) return false;
    this.stopCover();
    // this.unhappyAnimation.play();
    // this.stopAll('unhappy');
  }

  faceToBall(data) {
    // this.keeper.position.set(-1, 0, -0.6);

    Global.isJumpInProgress = false;
    this.keeperReady = true;
    this.shootStatus = null;
    this.ballCaught = false;
    this.stopCover();

    this.keeper.visible = true;
    this.keeperToCheer.visible = false;
    this.keeper.position.set(
      -0.85,
      0 /* 0.08  */ /* (Global.gender == 'Female' ? 0.08 : -0.07) */ /* - 0.3 */,
      -1.2 /* (Global.gender == 'Female' ? -0.05 : 0.1) */
    );
    this.keeper.lookAt(data.position);

    this.collider.position.set(
      -0.85,
      0 /*  0.08  */ /* (Global.gender == 'Female' ? 0.08 : -0.07) */ /* - 0.3 */,
      -0.8 /* (Global.gender == 'Female' ? -0.05 : 0.1) */
    );
    this.collider.lookAt(data.position);
    this.events.dispatchEvent({
      type: 'PLAYER_EVENTS',
      message: {
        event_type: 'move_camera_init',
        data: {},
      },
    });
    this.playIdle();
    // this.rightJumpAnimation2.play();
  }
  stopCover() {
    this.coverTwn && this.coverTwn.kill();
  }

  defend(data) {
    if (data.itemType !== 'keeper') return false;

    this.ballCaught = true;
  }
  playIdle() {
    this.shootStatus = null;
    Global.isJumpInProgress = false;
    this.playAnimation('idle', '');
    this.stopAll('idle', '');
  }

  playAnimation(level, side) {
    if (this.animKey == `${level}${side}`) return;
    if (side != '') {
      this[`${level}${side}Collider`].reset();
      this[`${level}${side}Collider`].time += 0.1;
      this[`${level}${side}Collider`].play();
      this.idle.crossFadeTo(this[`${level}${side}Collider`], 0.2, false);

      this.jumpLevel = level;
      this.jumpSide = side;
      this[`${level}${side}`].reset();
      this[`${level}${side}`].time += 0.1;
      this[`${level}${side}`].play();
      this.idle.crossFadeTo(this[`${level}${side}`], 0.2, false);

      // this[`${level}${side}`].play();
      // this[`${level}${side}Collider`] && this[`${level}${side}Collider`].play();
    } else {
      this.stopAll(level, side);
      this[`${level}${side}`].reset().play();
    }
    this.animKey = `${level}${side}`;

    if (side) {
      this.events.dispatchEvent({
        type: 'PLAYER_EVENTS',
        message: {
          event_type: 'focus_keeper',
          data: {
            z: 0.01,
          },
        },
      });
    }
  }
  playJumpRight() {
    // this.collider.visible = true;
    this.rightJumpAnimation1.play();
    this.rightJumpAnimation2.play();
    this.stopAll('right_jump');
  }

  playJumpLeft() {
    this.collider.visible = true;
    this.leftJumpAnimation1.play();
    this.leftJumpAnimation2.play();
    this.stopAll('left_jump');
  }

  update(data) {
    if (this.mixer)
      this.mixer.update(
        Global.delta *
          0.005 *
          (Global.isJumpInProgress
            ? Global.jumpHeight == 'high'
              ? isMobile
                ? 1.65
                : 1.9
              : 2.25
            : 1)
      );
    if (this.mixer2)
      this.mixer2.update(
        Global.delta *
          0.005 *
          (Global.isJumpInProgress
            ? Global.jumpHeight == 'high'
              ? isMobile
                ? 1.65
                : 1.9
              : 2.25
            : 1)
      );
    if (this.mixer3)
      this.mixer3.update(
        Global.delta *
          0.005 *
          (Global.isJumpInProgress
            ? Global.jumpHeight == 'high'
              ? isMobile
                ? 1.65
                : 1.9
              : 2.25
            : 1)
      );

    if (Global.isJumpInProgress) {
      const worldPosition = new THREE.Vector3();
      this.keeper.children[0].children[1].matrixWorld.decompose(
        worldPosition,
        new THREE.Quaternion(),
        new THREE.Vector3()
      );

      this.lastPosition = worldPosition;
    }
    if (this.keeper) {
      Global.keeperPos = this.keeper.position.clone();
    }
  }

  dispose() {
    // Remove the bounding box helper from the scene
    if (this.boundingBoxHelper) {
      this.scene.remove(this.boundingBoxHelper);
    }
    Global.isJumpInProgress = false;
    if (this.keeper) {
      this.keeper.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.keeper);
      this.keeper = null;
    }
    if (this.keeperToCheer) {
      this.keeperToCheer.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.keeperToCheer);
      this.keeperToCheer = null;
    }
    if (this.collider) {
      this.collider.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.collider);
      this.collider = null;
    }
    // if (this.colliderLJ) {
    //   this.colliderLJ.traverse((child) => {
    //     if (child.isMesh) {
    //       if (child.geometry) child.geometry.dispose();
    //       if (child.material) {
    //         if (Array.isArray(child.material)) {
    //           child.material.forEach((material) => material.dispose());
    //         } else {
    //           child.material.dispose();
    //         }
    //       }
    //     }
    //   });
    //   this.scene.remove(this.colliderLJ);
    //   this.colliderLJ = null;
    // }
    this.events.removeEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.removeEventListener('PLAYER_EVENTS', this.onEvents);
    this.events.removeEventListener('GAME_EVENTS', this.onEvents);
    this.stopAll();
  }
}
